































































































































































































































































































































































import { SfAddToCart, SfButton, SfHeading, SfLoader, SfPrice, SfRating, SfImage } from '@storefront-ui/vue';
import { ref, computed, defineComponent, PropType, toRef, onMounted, useContext } from '@nuxtjs/composition-api';

import {
  getName as getProductName,
  getPrice as getProductPrice,
  isInStock as isProductInStock,
} from '~/modules/catalog/product/getters/productGetters';

import useWishlist from '~/modules/wishlist/composables/useWishlist';
import HTMLContent from '~/components/HTMLContent.vue';
import AddToWishlist from '~/components/AddToWishlist.vue';
import HighlightBadge from '~/components/Sale/HighlightBadge.vue';
import { useUser } from '~/modules/customer/composables/useUser';
import { Product } from '~/modules/catalog/product/types';
import { useCart } from '~/modules/checkout/composables/useCart';
import ProductTabs from '~/modules/catalog/product/components/tabs/ProductTabs.vue';
import { useProductGallery } from '~/modules/catalog/product/composables/useProductGallery';

import { TabsConfig, useProductTabs } from '~/modules/catalog/product/composables/useProductTabs';
import GravurIcon from '~/components/utils/GravurIcon.vue';
import { useUiHelpers, useUiState, useApi, useUiNotification } from '~/composables';
import ProductDetails from '~/modules/catalog/product/components/ProductDetails.vue';
import ProductCouponCodeText from '~/modules/catalog/product/components/ProductCouponCodeText.vue';
import StaticBanner from '~/modules/catalog/product/components/StaticBanner.vue';

import PfEngravingModal from '~/modules/catalog/product/components/PfEngravingModal.vue';
import { useProductEngraving } from '~/modules/catalog/product/composables/useProductEngraving';

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

import ProductBrandLogo from '~/components/ProductBrandLogo.vue';

import ProductManufacturerCategorySection from '~/modules/catalog/product/components/ProductManufacturerCategorySection.vue';
import VuePhotoZoomPro from 'vue-photo-zoom-pro';
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css';
import base64 from 'base-64';

export default defineComponent({
  name: 'SimpleProduct',
  components: {
    ProductDetails,
    PfEngravingModal,
    HTMLContent,
    SfAddToCart,
    SfButton,
    SfHeading,
    SfLoader,
    SfPrice,
    SfRating,
    AddToWishlist,
    HighlightBadge,
    ProductTabs,
    SfImage,
    GravurIcon,
    VueSlickCarousel,
    ProductBrandLogo,
    VuePhotoZoomPro,
    ProductCouponCodeText,
    StaticBanner,
    ProductManufacturerCategorySection,
  },
  transition: 'fade',
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    isFetching: {
      type: Boolean,
      default: true,
    },
    isGiftAvailable: {
      type: String,
      default: '',
    },
    freeGifts: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      lightboxSliderSettings: {
        lazyload: 'ondemand',
        arrows: true,
        dots: true,
      },
      hoverTrue: false,

      stageSliderSettings: {
        lazyload: 'ondemand',
        arrows: false,
        dots: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              autoplay: true,
              draggable: true,
            },
          },
        ],
      },

      selectWidth: 800,
      selectHeight: 800,
      giftBannerSlideSettings: {
        lazyload: 'ondemand',
        autoplay: false,
        autoplaySpeed: 4500,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        dotsClass: 'slick-dots custom-dot-class',
        arrows: false,
      },
    };
  },
  mounted() {
    if (
      this.freeGifts &&
      this.freeGifts.mpFreeGiftsByProductSku &&
      this.freeGifts.mpFreeGiftsByProductSku[0] &&
      this.freeGifts.mpFreeGiftsByProductSku[0].banner_config &&
      'auto_play' in this.freeGifts.mpFreeGiftsByProductSku[0].banner_config
    ) {
      this.giftBannerSlideSettings.autoplay = this.freeGifts.mpFreeGiftsByProductSku[0].banner_config.auto_play;
    }
    if (
      this.freeGifts &&
      this.freeGifts.mpFreeGiftsByProductSku &&
      this.freeGifts.mpFreeGiftsByProductSku[0] &&
      this.freeGifts.mpFreeGiftsByProductSku[0].banner_config &&
      'auto_timeout' in this.freeGifts.mpFreeGiftsByProductSku[0].banner_config
    ) {
      this.giftBannerSlideSettings.autoplaySpeed = this.freeGifts.mpFreeGiftsByProductSku[0].banner_config.auto_timeout;
    }
    if (
      this.freeGifts &&
      this.freeGifts.mpFreeGiftsByProductSku &&
      this.freeGifts.mpFreeGiftsByProductSku[0] &&
      this.freeGifts.mpFreeGiftsByProductSku[0].banner_config &&
      'show_dots' in this.freeGifts.mpFreeGiftsByProductSku[0].banner_config
    ) {
      this.giftBannerSlideSettings.dots = this.freeGifts.mpFreeGiftsByProductSku[0].banner_config.show_dots;
    }
    if (
      this.freeGifts &&
      this.freeGifts.mpFreeGiftsByProductSku &&
      this.freeGifts.mpFreeGiftsByProductSku[0] &&
      this.freeGifts.mpFreeGiftsByProductSku[0].banner_config &&
      'show_next_prev_buttons' in this.freeGifts.mpFreeGiftsByProductSku[0].banner_config
    ) {
      this.giftBannerSlideSettings.arrows =
        this.freeGifts.mpFreeGiftsByProductSku[0].banner_config.show_next_prev_buttons;
    }
  },
  setup(props) {
    const { toggleCartSidebar } = useUiState();
    const { send: sendNotification } = useUiNotification();

    const bannerShow = ref(false);
    const bannerShowPosition = ref('');

    bannerShow.value = props?.freeGifts?.mpFreeGiftsByProductSku?.[0]?.banner_config?.images.length > 0 || false;
    bannerShowPosition.value = props?.freeGifts?.mpFreeGiftsByProductSku?.[0]?.banner_config?.position || '';

    const { app } = useContext();
    const { mutate } = useApi();

    const qty = ref(1);
    const product = toRef(props, 'product');
    const { addItem, error: cartError, loading: isCartLoading, canAddToCart, load: loadCart, cart } = useCart();
    const {
      app: { i18n },
    } = useContext();

    const apiState = app.$vsf.$magento.config.state;
    const allOptSelected = ref(false);
    const {
      engraving,
      engravingOptions,
      isEngravingLoading,
      shouldIncludeEngraving,
      isEngravingModalOpened,
      setActiveEngraving,
      setEngravingModalOpenState,
    } = useProductEngraving(product.value?.sku);

    const giftAddedAutomatic: any = {};

    const productShortDescription = computed(() => props.product?.short_description?.html || '<p></p>');

    const { productGallery, imageSizes } = useProductGallery(product);
    const { user, isAuthenticated } = useUser();
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    const { activeTab, setActiveTab, openNewReviewTab } = useProductTabs();

    const backInStock: any = {};

    const productPrice = computed(() => getProductPrice(props.product).regular);
    const productSpecialPrice = computed(() => getProductPrice(props.product).special);
    const addToCartError = computed(() => cartError.value?.addItem?.message);
    const productShippingCost = computed(() => props.product?.shipping_cost_data?.free_shipping_price || null);

    const productDiscount = productSpecialPrice.value ? productPrice.value - productSpecialPrice.value : 0;
    const currency = computed(() => apiState.getCurrency());

    const { trustedShopProductReviews } = useUiState();

    const averageRating = computed(() => trustedShopProductReviews.value.average);
    const totalReviews = computed(() => trustedShopProductReviews.value.total);

    const { getCatLink } = useUiHelpers();
    const productCategoriesList = computed(
      () =>
        props.product?.categories.map((category) => ({
          name: category.name,
          // @ts-ignore
          link: app.localePath(getCatLink(category)), // app.localePath(category.url_path),
        })) ?? [],
    );

    onMounted(async () => {
      setTimeout(() => {
        document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
        app.$gtm.push({ ecommerce: null });
        app.$gtm.push({
          event: 'view_item',
          ecommerce: {
            items: [
              {
                item_id: product.value.sku,
                item_name: product.value.name,
                price: productPrice.value,
                currency: currency.value,
                quantity: 1,
                discount: productSpecialPrice?.value,
                ...product.value?.categories?.reduce((acc, category, index) => {
                  acc[`item_category${index + 1}`] = category.name;
                  return acc;
                }, {}),
                item_brand: product.value?.custom_attributes?.find(
                  (attr) => attr.attribute_metadata.code === 'manufacturer',
                )?.selected_attribute_options?.attribute_option[0]?.label,
              },
            ],
          },
        });
      }, 3000);
    });

    const automaticAddGiftFn = async () => {
      if (props && props.freeGifts && props.freeGifts.mpFreeGiftsByProductSku) {
        props.freeGifts.mpFreeGiftsByProductSku.forEach((giftOverAll) => {
          console.log('Overall Gift', giftOverAll);
          let autoAddedArray = [];
          if (giftOverAll.auto_add && giftOverAll.auto_add === true) {
            const maxObject = giftOverAll.gifts.reduce((maxObj, obj) => {
              if (obj.value > maxObj.id) {
                return obj;
              }
              return maxObj;
            });
            console.log('maxObject : ', maxObject);
            autoAddedArray.push({ maxObject, ...giftOverAll.rule_id });
            console.log('This if auto added enable : ', autoAddedArray);
            autoAddedArray.forEach(async (autoItem) => {
              console.log('Item is', autoItem[0]);
              console.log('key is', autoItem['maxObject'].id);
              if (autoItem['maxObject'] && autoItem['maxObject'].id) {
                const mutateAddGiftGql = `
                mutation addGiftProduct(
                    $cart_id: String!
                    $rule_id: Int!
                    $gift_id: Int!
                ){
                    mpFreeGiftsAddGift(input: {
                        cart_id: $cart_id
                        rule_id: $rule_id
                        gift_id: $gift_id
                    }) {
                        message
                        status
                    }
                }
                `;
                const { data, errors } = await mutate(mutateAddGiftGql, {
                  cart_id: cart && cart.value && cart.value.id ? cart.value.id : null,
                  rule_id: parseInt(autoItem[0]),
                  gift_id: autoItem['maxObject'].id,
                });
                giftAddedAutomatic.value = data;
                if (giftAddedAutomatic && giftAddedAutomatic.value && giftAddedAutomatic.value.mpFreeGiftsAddGift) {
                  if (
                    giftAddedAutomatic.value.mpFreeGiftsAddGift.status &&
                    giftAddedAutomatic.value.mpFreeGiftsAddGift.status == 'error'
                  ) {
                    sendNotification({
                      id: Symbol('gift_added_error'),
                      message: i18n.t('An error occurred') as string,
                      type: 'danger',
                      icon: 'cross',
                      persist: false,
                      title: 'Error',
                    });
                  } else {
                    loadCart();
                    sendNotification({
                      id: Symbol('gift_added_success'),
                      message: i18n.t('Successfully added') as string,
                      type: 'success',
                      icon: 'check',
                      persist: false,
                      title: 'Success',
                    });
                    if (app && app.$gtm) {
                      let gift_price_value = autoItem['maxObject'].gift_price;
                      let gift_price_value_figure = gift_price_value.split(',');
                      const productObj = {
                        item_id: product.value.sku,
                        item_name: product.value.name,
                        price: productPrice.value,
                        currency: currency.value,
                        quantity: 1,
                        discount: productSpecialPrice?.value,
                        ...product.value?.categories?.reduce((acc, category, index) => {
                          acc[`item_category${index + 1}`] = category.name;
                          return acc;
                        }, {}),
                        item_brand: product.value?.custom_attributes?.find(
                          (attr) => attr.attribute_metadata.code === 'manufacturer',
                        )?.selected_attribute_options?.attribute_option[0]?.label,
                      };
                      app.$gtm.push({ ecommerce: null });
                      app.$gtm.push({
                        event: 'add_to_cart',
                        ecommerce: {
                          items: productObj,
                        },
                      });
                    }
                  }
                } else {
                  sendNotification({
                    id: Symbol('back_in_stock_notification_error'),
                    message: i18n.t('An error occurred') as string,
                    type: 'danger',
                    icon: 'cross',
                    persist: false,
                    title: 'Error',
                  });
                }
              } else {
                sendNotification({
                  id: Symbol('please_logged_in'),
                  message: i18n.t('You are not authorized, please log in') as string,
                  type: 'danger',
                  icon: 'cross',
                  persist: false,
                  title: 'Error',
                });
              }
            });
          } else {
            if (props.isGiftAvailable && document.getElementById('icon-gift-click')) {
              document.getElementById('icon-gift-click').click();
            } else {
              // toggleCartSidebar();
            }
          }
        });
      }
    };

    const checkAndNotify = () => {
      if (!addToCartError.value) {
        if (app && app.$gtm) {
          const productObj = {
            item_id: product.value.sku,
            item_name: product.value.name,
            price: productPrice.value,
            currency: currency.value,
            quantity: 1,
            discount: productSpecialPrice?.value,
            ...product.value?.categories?.reduce((acc, category, index) => {
              acc[`item_category${index + 1}`] = category.name;
              return acc;
            }, {}),
            item_brand: product.value?.custom_attributes?.find(
              (attr) => attr.attribute_metadata.code === 'manufacturer',
            )?.selected_attribute_options?.attribute_option[0]?.label,
          };
          app.$gtm.push({ ecommerce: null });
          app.$gtm.push({
            event: 'add_to_cart',
            ecommerce: {
              items: productObj,
            },
          });
        }
        automaticAddGiftFn();
        toggleCartSidebar();
      } else {
        sendNotification({
          id: Symbol('product_removed'),
          message: i18n.t(addToCartError.value) as string,
          type: 'danger',
          icon: 'error',
          persist: false,
        });
      }
    };

    const lightbox = ref(null);
    const lightboxOpen = ref(false);

    const openLightbox = (index) => {
      lightbox.value?.goTo(index);

      if (lightboxOpen.value == true) {
        lightboxOpen.value = false;
      } else {
        lightboxOpen.value = true;
      }

      const html = document.querySelector('html');
      html.classList.toggle('overflow-hidden');
    };

    const getProductShippingCost = () => {
      return props.product?.shipping_cost_data?.free_shipping_price || null;
    };
    const isShippingCostIncluded = () => {
      if (!product || !product.value || !product?.value?.shipping_cost_data) return false;

      let price = productSpecialPrice.value || productPrice.value || null;
      let productShippingCost = getProductShippingCost();

      if (price && productShippingCost) {
        let cost = parseFloat(productShippingCost);

        if (price > cost) return true;
      }

      return false;
    };

    const BackInStockEmailTrigger = async () => {
      if (product && product.value && product.value.uid && user && user.value && user.value.email) {
        const mutateBackInStockGql = `
          mutation backInStockNoti(
            $product_id: Int!
            $email: String!
          ){
            ProductAlertNotifyInStock(input: {
              product_id: $product_id
              email: $email
            }) {
              message
            }
          }
        `;
        const prodUidDecode = base64.decode(product.value?.uid);
        const { data, errors } = await mutate(mutateBackInStockGql, {
          product_id: prodUidDecode,
          email: user.value.email,
        });
        if (errors) {
          sendNotification({
            id: Symbol('back_in_stock_notification_error'),
            message: i18n.t('An error occurred') as string,
            type: 'danger',
            icon: 'cross',
            persist: false,
            title: 'Error',
          });
        } else {
          backInStock.value = data;
          sendNotification({
            id: Symbol('back_in_stock_notification_success'),
            message: i18n.t(backInStock.value.ProductAlertNotifyInStock.message) as string,
            type: 'success',
            icon: 'check',
            persist: false,
            title: 'Success',
          });
        }
      } else {
        sendNotification({
          id: Symbol('please_logged_in'),
          message: i18n.t('You are not authorized, please log in') as string,
          type: 'danger',
          icon: 'cross',
          persist: false,
          title: 'Error',
        });
      }
    };

    return {
      checkAndNotify,
      engraving,
      isEngravingLoading,
      shouldIncludeEngraving,
      isEngravingModalOpened,
      setActiveEngraving,
      setEngravingModalOpenState,
      engravingOptions,
      addItem,
      addItemToWishlist: addOrRemoveItem,
      averageRating,
      totalReviews,
      canAddToCart,
      isAuthenticated,
      user,
      isInWishlist: computed(() => isInWishlist({ product: props.product })),
      isCartLoading,
      productShortDescription,
      productGallery,
      getProductName,
      productPrice,
      productSpecialPrice,
      productDiscount,
      qty,
      imageSizes,
      setActiveTab,
      openNewReviewTab,
      activeTab,
      TabsConfig,
      addToCartError,
      productCategoriesList,
      toggleCartSidebar,
      openLightbox,
      lightbox,
      lightboxOpen,
      BackInStockEmailTrigger,

      isShippingCostIncluded,
      getProductShippingCost,

      isProductInStock,
      bannerShow,
      bannerShowPosition,
      allOptSelected,
    };
  },
  methods: {
    async addProductToCart() {
      let payload: any = {
        product: this.product,
        quantity: this.qty,
      };

      if (this.shouldIncludeEngraving) {
        payload.engravingOptions = this.engravingOptions;
      }

      await this.addItem(payload);

      this.checkAndNotify();
    },

    handleUpdate(e) {
      this.selectWidth = e.width;
      this.selectHeight = e.height;
    },

    changeSlide(index) {
      (this.$refs.stage as any).goTo(index);
    },
  },
});
